import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';   // initializes react-i18next before App mounts
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the PWA service worker so the app is installable on mobile
// (Add to Home Screen on iOS, Install App on Chrome/Android). The SW only
// activates in production — registering during local dev would interfere
// with hot reload. localhost is also fine because it's treated as secure
// origin like https://.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log('PWA: service worker registered, scope:', reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('PWA: service worker registration failed:', err);
      });
  });
}
